import { render, staticRenderFns } from "./passForbiden_normal.vue?vue&type=template&id=5150fcb8&scoped=true"
import script from "./passForbiden_normal.vue?vue&type=script&lang=js"
export * from "./passForbiden_normal.vue?vue&type=script&lang=js"
import style0 from "./passForbiden_normal.vue?vue&type=style&index=0&id=5150fcb8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5150fcb8",
  null
  
)

export default component.exports